import React from 'react';

class Underliner extends React.Component {
  render() {
    return (
      <div className={`underliner ${this.props.className}`}>
        {this.props.children}
        <div className="line">
          <div className="color-cnt"><div /></div>
        </div>
      </div>
    )
  }
}

export default Underliner;



// WEBPACK FOOTER //
// ./src/scripts/components/underliner.js